export default class TaxRate {
  public id: string;
  public description: string;
  public displayName: string;
  public inclusive: boolean;
  public percentage: number;

  constructor(options) {
    this.id = options.id;
    this.description = options.description;
    this.displayName = options.displayName;
    this.inclusive = options.inclusive;
    this.percentage = options.percentage;
  }
}
